import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { LogsList } from "../../components/logs/LogsList";

export const Logs: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("logs");

  return (
    <MainContentArea
      header={<ContentHeader title={t("logs.title")} breadcrumb={breadcrumb} />}
    >
      <LogsList />
    </MainContentArea>
  );
};
